// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4105":"css/app-rtl","5073":"css/app-dark","8252":"css/app"}[chunkId] + ".css";
};